import { render, staticRenderFns } from "./RealizarVenta.vue?vue&type=template&id=0f898b6d&scoped=true"
import script from "./RealizarVenta.vue?vue&type=script&lang=js"
export * from "./RealizarVenta.vue?vue&type=script&lang=js"
import style0 from "./RealizarVenta.vue?vue&type=style&index=0&id=0f898b6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f898b6d",
  null
  
)

export default component.exports